export enum SubscriptionSuspendReason {
  ByAdmin = 'BY_ADMIN',
  ByOwner = 'BY_OWNER',
  ByManyRejectedAttempts = 'BY_MANY_REJECTED_ATTEMPTS',
}
